export const AUTH_TOKEN_ID = 'mozio-auth-token'
export const REFRESH_TOKEN_ID = 'mozio-refresh-token'
export const SIGNUP_FORM = 'signup-form'
export const EMAIL_FIELD = 'email'
export const PASSWORD_FIELD = 'password'
export const CONFIRM_PASSWORD_FIELD = 'confirm-password'
